module.exports = __webpack_public_path__ + "img/webhook-icon.28496bd6.svg";